import { registerDecorator } from "class-validator";
import { DateTime } from "luxon";
export function IsBeforeDateTime(property, orEqual = false, validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: "isBeforeDateTime",
            target: object.constructor,
            propertyName,
            constraints: [property, orEqual],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    const [relatedPropertyName, orEqual] = args.constraints;
                    const relatedValue = args.object[relatedPropertyName];
                    return (DateTime.isDateTime(value) &&
                        DateTime.isDateTime(relatedValue) &&
                        (orEqual ? value <= relatedValue : value < relatedValue));
                },
            },
        });
    };
}
export function IsAfterDateTime(property, orEqual = false, validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: "isAfterDateTime",
            target: object.constructor,
            propertyName,
            constraints: [property, orEqual],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    const [relatedPropertyName, orEqual] = args.constraints;
                    const relatedValue = args.object[relatedPropertyName];
                    return (DateTime.isDateTime(value) &&
                        DateTime.isDateTime(relatedValue) &&
                        (orEqual ? value >= relatedValue : value > relatedValue));
                },
            },
        });
    };
}
//# sourceMappingURL=beforeAfter.js.map